import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAgentListScripts } from "../../Redux/Actions";
import AgentCCP from "../../Components/AgentCCP";
import CallPageForm from "../../Components/CallPageForm";
import CallScreenComponent from "./CallScreenComponent";
import useWindowDimensions from "../../Hooks/useWindowDimensions";

export default function Index() {
  const dispatch = useDispatch();
  const call = useSelector((state) => state.Call);
  const { width } = useWindowDimensions();
  const isMobile = width <= 768;

  useEffect(() => {
    dispatch(getAgentListScripts());
    const containerDiv = document.getElementById("container-div-1");
    const newContainerDiv = document.getElementById("new-container-div-1");
    newContainerDiv.appendChild(containerDiv.children[0].cloneNode(true));
    return () => {
      newContainerDiv.remove();
    };
  }, []);

  return (
    <>
      <div className="full-body w-full bg-gray-50">
        <div className={`${isMobile ? 'px-4 pt-8 block' : 'pl-5 pr-24 pt-8 flex'} bg-gray-50`}>
          <AgentCCP isMobile={isMobile} />
          {call.phoneNumber.length > 0 &&
            (call.cuCustomer ? <CallScreenComponent isMobile={isMobile} /> : <CallPageForm isMobile={isMobile} />)}
        </div>
      </div>
    </>
  );
}
